import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { LogoMark } from "./Logo";
import { NAV_LINKS, AREAS } from "../data/content";
import { scrollToId, PHONE, PHONE_HREF } from "../lib/scroll";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[#0B0C10] border-t border-white/10 overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 pt-16 grid sm:grid-cols-2 lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <LogoMark className="h-16 w-16" />
        <p className="mt-6 font-display text-2xl font-bold text-white max-w-sm">More than a contractor. A property operations partner.</p>
        <a href={PHONE_HREF} data-testid="footer-phone" className="btn-primary mt-6">
          <Phone className="h-4 w-4" /> {PHONE}
        </a>
      </div>
      <div className="lg:col-span-3">
        <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">Navigate</p>
        <ul className="mt-4 space-y-2.5">
          {NAV_LINKS.map((l) => (
            <li key={l.id}>
              <button onClick={() => scrollToId(l.id)} data-testid={`footer-link-${l.id}`} className="text-zinc-300 hover:text-[#FF6B00] transition-colors">{l.label}</button>
            </li>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-4">
        <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">Service Areas</p>
        <p className="mt-4 text-zinc-300 leading-relaxed">{AREAS.map((a) => a.name).join(" · ")}</p>
        <p className="mt-6 text-zinc-300">19 Sarrazin Way, Nepean, Ottawa, ON K2J 4A5</p>
      </div>
    </div>
    <motion.p
      initial={{ y: "40%", opacity: 0 }}
      whileInView={{ y: "0%", opacity: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
      className="select-none font-display font-black leading-[0.8] tracking-[-0.06em] text-[28vw] text-center text-white/[0.06] mt-10"
      aria-hidden="true"
    >
      LHGS
    </motion.p>
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 py-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 text-xs text-zinc-400">
      <p>© {new Date().getFullYear()} LHGS Property Operations & Contracting Group. Ottawa, Ontario.</p>
      <p>Waste services in partnership with Cornerstone Waste Solutions Canada Ltd.</p>
    </div>
  </footer>
);
